/**
 * 异步加载 JS
 * @param {string} url JS链接
 * @param {string} root JS暴露的全局变量, js标签名
 */
export async function scriptLoader(url: string, root: string): Promise<boolean> {
  const complateKey = 'complate';
  return new Promise(resolve => {
    const body = document.querySelector('body');
    let s = document.getElementById(root) as HTMLScriptElement;
    if (!s || !(s instanceof HTMLScriptElement)) {
      s = document.createElement('script');
      s.type = 'text/javascript';
      s.id = root;
      s.src = url;
      body && body.appendChild(s);
    }

    s.addEventListener('load', () => {
      console.log(`${root} script load complate!`);
      s.setAttribute(complateKey, '1');
      // eslint-disable-line
      resolve(true);
    });
    s.addEventListener('error', () => {
      body?.removeChild(s);
      resolve(false);
    });
    s.getAttribute(complateKey) && resolve(true);
  });
}
